import React from 'react';
import { PageHeader } from 'antd';
import { MyBreadcrumb } from 'utils';
import CompaniesForm from './form';
export default function CompaniesUpdate(props) {
    const { id } = props.match.params;
    return (
        <div>
            <MyBreadcrumb items={[{ label: "Companies", path: "/companies" }, { label: "Update", path: "" }]} />
            <PageHeader
                ghost={false}
                onBack={() => window.history.back()}
                title="Update"
                subTitle=""
            >
                <CompaniesForm id={id} />
            </PageHeader>
        </div>
    );
}